import AccountUnbind from './src/account-unbind';

export default AccountUnbind;
